
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.221 15.99c.923 0 1.617-.23 2.082-.692.465-.461.697-1.145.697-2.05V2.743c0-.905-.232-1.589-.697-2.05C14.838.23 14.144 0 13.221 0H2.779C1.862 0 1.169.23.702.688.234 1.147 0 1.83 0 2.743v10.505c0 .912.234 1.596.702 2.055.467.459 1.16.688 2.077.688h10.442zm-.064-1.557H2.843c-.407 0-.722-.11-.943-.328-.222-.219-.333-.544-.333-.975V2.86c0-.431.111-.756.333-.975.221-.219.536-.328.943-.328h10.314c.407 0 .723.11.948.328.224.219.337.544.337.975V13.13c0 .431-.113.756-.337.975-.225.218-.54.328-.948.328zm-6.086-2.36c.31 0 .555-.143.738-.428l3.918-6.114c.048-.091.095-.186.14-.283a.683.683 0 00.07-.291c0-.2-.078-.363-.233-.488a.802.802 0 00-.515-.187c-.255 0-.47.14-.647.42l-3.499 5.594-1.64-2.114a.96.96 0 00-.314-.269.772.772 0 00-.342-.077.718.718 0 00-.72.729c0 .188.073.377.219.565l2.06 2.515c.115.152.233.26.355.328.121.066.258.1.41.1z","fill":"#AAB4C0"}})])
          )
        }
      }
    